module.exports = __webpack_public_path__ + "img/rx.3717b1f9.svg";